import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import DishCard from './components/DishCard';
import RandomButton from './components/RandomButton';
import FullscreenVideo from './components/FullscreenVideo';

function App() {
  const [selectedDish, setSelectedDish] = useState(null);
  const [dishes, setDishes] = useState([]);
  const [showVideo, setShowVideo] = useState(false);

  const handleVideoEnd = () => {
    setShowVideo(false);
    handleRandomSelect(); // 使用正确的函数名
  };

  const handleButtonClick = () => {
    setShowVideo(true);
  };
  const fetchDishes = async () => {
    try {
      const response = await fetch('/api/dishes');
      if (!response.ok) {
        throw new Error(`请求失败: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('获取数据失败:', error);
      throw error; // 将错误向上传递
    }
  };
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchDishes();
        setDishes(result);
      } catch (error) {
        // 需要添加错误状态处理
      }
    };
    fetchData();
  }, []);
  const handleRandomSelect = () => {
    if (dishes.length === 0) return;
    
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * dishes.length);
    } while (
      selectedDish && 
      dishes[newIndex].name === selectedDish.name && 
      dishes.length > 1
    );
    
    setSelectedDish(dishes[newIndex]);
  };

  return (
    <div className="app-container">
      <Header />
      <div className="dishes-container">
        {selectedDish ? (
          <DishCard
            key={selectedDish.name}
            {...selectedDish}
          />
        ) : (
          dishes.slice(0, 5).map((dish, index) => (
            <DishCard key={index} name={dish.name} description={dish.description} image={dish.image} />
          ))
        )}
      </div>
      {showVideo && (
        <FullscreenVideo
          src="/videos/index.m3u8"
          onEnd={handleVideoEnd}
        />
      )}
      <RandomButton onSelect={handleButtonClick} dishes={dishes} />
    </div>
  );
}


export default App;